import { Component, ChangeDetectorRef } from '@angular/core';
import { CustomFormControlComponentBase } from '@mt-ng2/dynamic-form';

@Component({
    selector: 'tweb-auth-input-dynamic-field-component',
    template: `
        <dynamic-form-input-wrapper [parentControl]="thisControl" [formGroup]="getGroup()">
            <div class="input-scaffold">
                <label class="input-label">
                    <span class="input-scaffold__label">{{ config.label }}</span>
                    <input
                        #inputElement
                        class="input-scaffold__input input-rounded"
                        [attr.type]="'text'"
                        [attr.placeholder]="config.placeholder"
                        (focus)="onFocus()"
                        (blur)="onBlur()"
                        [formControlName]="config.name"
                        [maxlength]="getMaxLength()"
                    />
                </label>
            </div>
            <span
                *ngIf="!config.labelLeft && hasMaxLength()"
                [style.visibility]="isFocused && hasMaxLength() ? null : 'hidden'"
                class="small pull-right"
                [class.errortext]="hasError('maxlength')"
                [class.inside-box-maxlength]="config.insideBoxValidation"
                >{{ getMaxLengthText() }}</span
            >
            <span
                *ngIf="config.labelLeft"
                [style.visibility]="isFocused && hasMaxLength() ? null : 'hidden'"
                class="small pull-right"
                [class.errortext]="hasError('maxlength')"
                [class.inside-box-maxlength]="config.insideBoxValidation"
                >{{ getMaxLengthText() }}</span
            >
            <!-- validation elements -->
            <div *ngIf="config.validators">
                <div *ngIf="showRequired() && hasError('required')" class="small" [class.inside-box-validation]="config.insideBoxValidation">
                    {{ config.label }} is required
                </div>
                <div *ngIf="hasError('minlength')" class="small" [class.inside-box-validation]="config.insideBoxValidation">
                    {{ config.label }} must be at least {{ config.validators.minlength }} characters
                </div>
                <div
                    *ngIf="!hasError('required') && hasError('email')"
                    class="small errortext"
                    [class.inside-box-validation]="config.insideBoxValidation"
                >
                    Invalid email address. Valid e-mail can contain only letters, numbers and '@'
                </div>
            </div>
        </dynamic-form-input-wrapper>
    `,
})
export class TwebAuthInputComponent extends CustomFormControlComponentBase {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    ngOnInit(): void {
        this.config.insideBoxValidation = true;
    }
}
